import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import UploadCSVFileList from "./child/UploadWithCSVPreview";
import ExportCSVButton from "./child/ExportCSV";

const LeadsPageLayer = () => {

  const sampleData = [
    { name: 'Aniket', email: 'aniket@example.com' },
    { name: 'Rohit', email: 'rohit@example.com' }
  ];
  return (
    <div
      style={{
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        height: '100vh',
        padding: '1rem',
      }}
    >
      <div className="fw-bold text-xl text-black mb-4">Leads ({"0"})</div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {/* Left Side - Search + Export */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <form style={{
            display: 'flex', alignItems: 'center', gap: '0.5rem', border: '1px solid #ccc',
            borderRadius: '0.5rem',
          }}>
            <Icon icon="ion:search-outline" className="icon mx-3" />
            <input
              type="text"
              name="search"
              placeholder="Search by phone number"

              style={{
                padding: '0.4rem',

              }}
            />
          </form>


          <ExportCSVButton data={sampleData} filename="contacts.csv" />
        </div>

        {/* Right Side - Items Per Page + Import */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div className="dropdown">
            <button
              className="btn text-primary-600 hover-text-primary px-10 py-8 dropdown-toggle toggle-icon"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Items Per Page
            </button>
            <ul className="dropdown-menu">
              {[10, 20, 30].map((num) => (
                <li key={num}>
                  <Link
                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                    to="#"
                  >
                    {num}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <UploadCSVFileList />
        </div>
      </div>
      <br style={{color: "black"}}/>
    </div>
  );
};

export default LeadsPageLayer;
